import { render, staticRenderFns } from "./communication-header.vue?vue&type=template&id=0d2d64c5"
import script from "./communication-header.vue?vue&type=script&lang=js"
export * from "./communication-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports